import { useStore } from '@/services/layer-management-service/store'

// For ease of transition
// FUTURE - update consumers to directly use these
const store = useStore()
/**
 * *(AI-generated)*
 * Returns the initial stylesheet from the layer management store.
 */
export const initialStylesheet = () => store.initialStylesheet.value
/**
 * *(AI-generated)*
 * Returns the current stylesheet from the layer management store.
 */
export const stylesheet = () => store.stylesheet.value
/**
 * *(AI-generated)*
 * Returns the current shown layers map from the layer management store.
 */
export const shownLayers = () => store.shownLayers.value
/**
 * *(AI-generated)*
 * Returns the current layer opacities from the layer management store.
 */
export const layerOpacities = () => store.layerOpacities.value
/**
 * *(AI-generated)*
 * Returns the current layer filters from the layer management store.
 */
export const layerFilters = () => store.layerFilters.value
/**
 * *(AI-generated)*
 * Returns the current stylesheet sources from the layer management store.
 */
export const stylesheetSources = () => store.stylesheetSources.value

export {
  enableUserLayersForTags,
  getActiveTags,
  getInactiveTags,
  initializeLMS,
  layerManagementReady,
  setLayerManagementReady,
  showLayers,
  hideLayers,
  setLayerOpacities,
  setLayerFilters,
  updateSource,
  setMaxSourceZoom,
  resetMaxSourceZoom,
  resetUserLayersForTags,
  setUserLayerOpacity,
  setUserLayerTagsActive,
  toggleUserLayerActive,
  getDefaultLayerFilter,
  getLayersByIdPrefix,
} from '@/services/layer-management-service/initialize'
